import gql from 'graphql-tag';

export const mutationViewDokkioObject = gql`
  mutation viewDokkioObject (
    $id: DokkioID!
  ) {
    viewDokkioObject (
      id: $id
    )
  }
`;
export default mutationViewDokkioObject;
